__webpack_require__.p = "https://app-staticfiles.blr1.cdn.digitaloceanspaces.com/talent/staging/releases/2-20260720-1239/";